import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=22b8a583&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=22b8a583&lang=scss&scoped=true&"
import style1 from "./changePassword.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8a583",
  null
  
)

export default component.exports